import { API_BASE_URL } from './apiConfig';

export const getToken = () => sessionStorage.getItem('casapizza_token');

export const getUser = () => {
  const raw = sessionStorage.getItem('casapizza_user');
  return raw ? JSON.parse(raw) : null;
};

export const login = async (username, password) => {
  const response = await fetch(`${API_BASE_URL}/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password }),
  });
  if (!response.ok) {
    const err = await response.json();
    throw new Error(err.detail || 'Credenciales incorrectas');
  }
  const data = await response.json();
  sessionStorage.setItem('casapizza_token', data.access_token);
  sessionStorage.setItem('casapizza_user', JSON.stringify({ username: data.username, role: data.role }));
  return data;
};

export const logout = () => {
  sessionStorage.removeItem('casapizza_token');
  sessionStorage.removeItem('casapizza_user');
  sessionStorage.removeItem('casapizza_restaurant');
};

// Se llama cuando cualquier request a la API responde 401 — limpia la sesión
// y regresa al login en vez de dejar que el error falle en silencio (pasa
// para tokens expirados y, tras T33-T35, para tokens emitidos antes de ese
// cambio que ya no llevan restaurant_id).
export const handleUnauthorized = () => {
  logout();
  if (window.location.pathname !== '/login') {
    window.location.href = '/login';
  }
};
